<template>
  <div class="x-padding userInfo">
    <div class="x-margin-b x-border-50">
      <my-head-title showBack :title="$t('HT.userInfo.title')" :showEdit="false"></my-head-title>
      <div class="x-padding-info">
        <my-info-item :title="$t('HT.addUser.user')">
          <span class="x-margin-r">{{ userData.username }}</span>
          <span class="change" v-if="ownerData.supervisor" @click="showUsername">{{
            $t('HT.edit2')
          }}</span>
          <el-tag v-if="userData.supervisor" size="mini">{{ $t('HT.userInfo.super') }}</el-tag>
        </my-info-item>
        <my-info-item :title="$t('HT.addUser.nickname')">
          <span>{{ userData.nickname }}</span>
          <span v-if="$hasModule(27)" class="change" @click="showNickname">{{
            $t('HT.edit2')
          }}</span>
        </my-info-item>
        <my-info-item :title="$t('HT.personal.phone')">
          <span>{{ userData.phone }}</span>
          <span v-if="$hasModule(27)" class="change" @click="showTelphone">{{
            $t('HT.edit2')
          }}</span>
        </my-info-item>
        <my-info-item :title="$t('HT.personal.text3')">
          <span>{{ isOwer }}</span>
        </my-info-item>
        <my-info-item :title="$t('HT.addUser.email')">
          <span v-if="userData.email">{{ userData.email }}</span>
          <template v-if="$hasModule(27)">
            <span v-if="userData.email" class="change" @click="showBing">{{ $t('HT.edit2') }}</span>
            <ux-button v-else type="text" @click="showBing">{{ $t('HT.bindEmail') }}</ux-button>
          </template>
        </my-info-item>
        <my-info-item
          ref="pass"
          :title="$t('HT.addUser.psw')"
          password
          :isAdmin="ownerData.supervisor"
          :showButton="$hasModule(27)"
          @editPass="editPass"
        ></my-info-item>
        <my-info-item :title="$t('HT.router.userListGroup')">
          <span v-for="item in group_list" :style="{ 'margin-left': 10 + 'px' }">{{ item }}</span>
          <span
            v-if="group_list[0] && ownerData.supervisor && userData.owner"
            class="change"
            @click="showGroup"
            >{{ $t('HT.edit2') }}</span
          >
        </my-info-item>
      </div>
    </div>
    <div class="x-table-box" v-if="userData.owner">
      <!-- 搜索行 -->
      <ux-searchOption :layout="layout" @add="showAdd"></ux-searchOption>
      <ux-table
        ref="table"
        maxHeight="100%"
        :emptyText="$t('HT.nodata')"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import bindEmail from './template/bindEmail';
import changeNickname from './template/changeNickname';
import changeUsername from './template/changeUsername';
import showTelphone from './template/changeTel';
import showGroup from './template/showGroup';
import addUser from './template/addUser';
export default {
  components: {
    bindEmail,
    changeNickname,
    showTelphone,
    showGroup,
    addUser,
    changeUsername
  },
  data() {
    return {
      userData: {}, // 详情数据
      ownerData: {}, // 用户信息
      id: this.$route.query.id,
      showOption: this.$route.query.showOption,
      isSuper: this.$route.query.isSuper, //isSuper用于详情列表添加用户权限的限制
      group_list: [], //用户组里的用户名
      layout: [
        // 搜索项配置
        {
          type: 'button',
          text: this.$t('HT.userInfo.add'),
          left: true,
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addUser.user'),
          tooltip: true,
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.childrenInfo(params);
                  }
                }
              },
              params.username
            );
          }
        },
        {
          label: this.$t('HT.addUser.nickname'),
          prop: 'nickname',
          tooltip: true
        },
        {
          label: this.$t('HT.addUser.phone'),
          prop: 'phone',
          tooltip: true
        },
        {
          label: this.$t('HT.addUser.email'),
          prop: 'email',
          tooltip: true
        },

        {
          label: this.$t('HT.operation'),
          hidden: false,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.addChannel.close'), this.$t('HT.addChannel.open')],
                className: [!params.disabled ? 'no-click' : '', params.disabled ? 'no-click' : ''],
                colors: ['#f45c5c', '#0087ff'],
                event: ['toDisable', 'toStart']
              },
              on: {
                toDisable: () => {
                  this.forDisable(params);
                },
                toStart: () => {
                  this.forDisable(params);
                }
              }
            });
          }
        }
      ],
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      groupList: [] //主账号用户组信息
    };
  },
  created() {
    this.ownerData = this.$store.state.login.userData;
    this.getInfo(this.id);
  },
  watch: {
    $route(to) {
      this.id = to.query.id;
      this.getInfo(to.query.id);
    }
  },
  computed: {
    isOwer() {
      return this.userData.owner ? this.$t('HT.personal.text4') : this.$t('HT.personal.text5');
    }
  },
  methods: {
    /**
     * 详情页子账号
     * @param {Object} params 请求参数
     */
    childrenInfo(params) {
      this.$router.push({
        name: 'userInfo',
        query: { id: params.id }
      });
      this.getInfo(params.id);
    },
    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.userInfo.addAccount');
      this.$uxModal.show({
        title,
        // hideBtn: true,
        content: (h) => {
          return h(addUser, {
            props: {
              list: this.groupList, //非超级管理员的主账号用户组信息传递给弹窗
              showOption: JSON.parse(this.showOption) //不知道为啥这个变成了string  所以需要转换一下
              // isSuper:this.isSuper
            }
          });
        },
        confirm: (data) => {
          const nocheckData = JSON.parse(JSON.stringify(data));
          if (this.ownerData.supervisor && this.isSuper) {
            // 数字转换成数组
            nocheckData.group_ids = Array.of(nocheckData.group_ids);
            // 非超管主账号
          } else {
            let valArr = [];
            for (let item of this.groupList) {
              valArr.push(item.value);
            }
            nocheckData.group_ids = valArr;
            nocheckData.space_id = this.userData.space_id;
          }

          this.addList(nocheckData);
        }
      });
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      // 判断添加主账号还是子账号
      let api = this.ownerData.supervisor && this.isSuper ? 'addList1' : 'addList2';
      this.$api.user[api](params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getInfo(this.id);
        }
      });
    },
    /**
     * 方法
     * @param {Object} params 查询对象
     */
    forDisable(params) {
      this.$api.system.disableAndstart(params.id, { disabled: !params.disabled }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          params.disabled === true
            ? this.$uxMessage.success(this.$t('HT.addApi.disabledSuccess'))
            : this.$uxMessage.success(this.$t('HT.addApi.enabledSuccess'));
          this.getInfo(this.id);
        }
      });
    },

    /**
     * 获取账号信息
     */
    getInfo(id) {
      this.$api.system.usergroupInfo(id).then((res) => {
        if (res.code == 10000) {
          const list = [];
          this.userData = res.data;
          for (let item of res.data.group_list) {
            list.push(item.group_name);
          }
          // 保存所有用户组下面的用户名
          this.group_list = list;
          // 表格数据
          this.tableData.list = res.data.child_account_vo; // ?没更新吗？？？
          // 主账号的用户组信息
          this.groupList = res.data.group_list.map((item) => {
            return {
              label: item.group_name,
              value: item.id
            };
          });
        }
      });
    },
    // 修改登录账号弹窗
    showUsername() {
      const title = this.$t('HT.userInfo.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(changeUsername);
        },
        confirm: (val) => {
          this.changeUsername(val);
        }
      });
    },
    // 修改用户名
    changeUsername(val) {
      this.$api.system.changeGroupInfo(this.id, { username: val.username }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          this.getInfo(this.id);
        }
      });
    },
    // 修改姓名弹窗
    showNickname() {
      const title = this.$t('HT.userInfo.editNick');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(changeNickname);
        },
        confirm: (val) => {
          this.changeNickname(val);
        }
      });
    },

    // 修改用户昵称
    changeNickname(val) {
      this.$api.system.changeGroupInfo(this.id, { nickname: val.changeNickname }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          this.getInfo(this.id);
        }
      });
    },
    // 修改手机号码弹窗
    showTelphone() {
      const title = this.$t('HT.userInfo.editPhone');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(showTelphone);
        },
        confirm: (val) => {
          this.changePhone(val);
        }
      });
    },
    // 修改手机号
    changePhone(val) {
      this.$api.system.changeGroupInfo(this.id, { phone: val.changePhone }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          this.getInfo(this.id);
        }
      });
    },
    // 修改用户分组弹窗
    showGroup() {
      const title = this.$t('HT.userInfo.editGroup');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(showGroup);
        },
        confirm: (val) => {
          const joinGroupArr = Array.of(val.group_ids);
          this.changeGroup(joinGroupArr);
        }
      });
    },
    // 修改用户分组
    changeGroup(val) {
      this.$api.system.changeGroupInfo(this.id, { group_ids: val }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          this.getInfo(this.id);
        }
      });
    },
    // 绑定邮箱的弹窗
    showBing() {
      const title = this.$t('HT.bindEmail');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindEmail);
        },
        confirm: (val) => {
          this.email(val);
        }
      });
    },

    /**
     * 绑定邮箱
     * @param {Object} params 表单对象
     */
    email(params) {
      this.$api.system.changeGroupInfo(this.id, { email: params.email }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$set(this.userData, 'email', params.email);
          this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
        }
      });
    },

    /**
     * 修改登录密码
     * @param {Object} val 新密码旧密码
     */
    editPass(val) {
      this.$uxLoading.show();
      let postData = {
        new_pwd: val.password,
        old_pwd: val.oldPassword || null
      };
      this.$api.system.changeGroupInfo(this.id, postData).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          this.getInfo(this.id);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.userInfo {
  height: 100%;

  .x-table-box {
    height: 100%;
  }
}

.change {
  margin-left: 20px;
  color: $color-primary;
  cursor: pointer;
}
</style>
